import React, { useState, useEffect } from 'react'
import { ShootingSchedule, Option } from '../../../models/_models'
import ShootingSchedules from '../../shooting-schedules'
import classes from '../../_pages/appointment-selection/appointment-selection.module.sass'

const useShootingSchedules = (schoolId, optionId) => {
  const [shootingSchedules, setShootingSchedules] = useState([])

  // Option-aware, span-checked bookable start-times (single source of truth).
  // ShootingSchedules renders nothing without an option, so skip until we have one.
  useEffect(() => {
    if (!optionId) return

    ShootingSchedule
      .selectExtra(['bookableTimeslots'])
      .where({ schoolId, optionId })
      .order('startTime')
      .all()
      .then((res) => setShootingSchedules(res.data))
  }, [schoolId, optionId])

  return shootingSchedules
}

const useOption = (optionId) => {
  const [option, setOption] = useState(null);

  useEffect(() => {
    Option
      .find(optionId)
      .then((res) => setOption(res.data))
  }, [optionId])

  return option
}

const AppointmentSelection = ({ schoolId, optionId, initialSelectedDay, initialSelectedTime, index }) => {
  const shootingSchedules = useShootingSchedules(schoolId, optionId)
  const option = useOption(optionId)
  const [appt, setAppt] = useState()
  const school = { id: schoolId }

  return (
    <>
      <input name={`order[cart_attributes][order_packages_attributes][${index}][appointment_time]`}
             value={appt}
             hidden/>
      <div className={classes.container}>
        {option && (
          <ShootingSchedules
            initialSelectedDay={initialSelectedDay}
            initialSelectedTime={initialSelectedTime}
            schedules={shootingSchedules}
            setAppt={setAppt}
            selectedOption={option}
            school={school}
          />
        )}
      </div>
    </>
  )
}

export default AppointmentSelection

